import script from "./SalesRebateSchemaNote.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesRebateSchemaNote.vue?vue&type=script&setup=true&lang=ts"

import "./SalesRebateSchemaNote.vue?vue&type=style&index=0&id=8d582128&lang=css"

const __exports__ = script;

export default __exports__